import { Space, Tag } from 'antd';
import { LockOutlined } from '@ant-design/icons';

import useLocale from '../../../hooks/useLocale';
import StatusTag from './StatusTag';
import { COMMAND_HOLDING_TAG_COLOR } from './constants';
import type { CommandStatus } from './types';
import { getStatusLabel, getStatusPresentation } from './utils';

interface IProps {
  status?: CommandStatus;
  isHolding?: boolean;
}

const CommandStatusTag = ({ status, isHolding }: IProps): JSX.Element => {
  const { t } = useLocale();

  return (
    <Space size={4} wrap>
      <StatusTag presentation={getStatusPresentation(status)} label={getStatusLabel(status, t)} />
      {isHolding && (
        <Tag color={COMMAND_HOLDING_TAG_COLOR} icon={<LockOutlined />}>
          {t.INTEGRATION_HOLDING_TAG}
        </Tag>
      )}
    </Space>
  );
};

export default CommandStatusTag;
